import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterDataset_template} from "./filterDataset_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;

export class tagTypesList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected datasetFilter: filterDataset_template;

    protected getTemplateHtml(): string {

        return /* html */`

            <div class="list-header w-justify" >

                <div class="w-left">
                    <!-- ko ifnot: brandId -->
                    <button data-bind=" click: onClickShowPopUp" class="btn secondary icon i-add" type="button">Add Tag Type</button>
                    <!-- /ko -->
                    ${this.datasetFilter.getHtmlBuild()}
                </div>

                <div class="w-center">${ this.filter.getHtmlBuild() }</div>

                <div class="w-right">
                    <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                        <div class="pagination">
                            <input data-bind="value: pageNumber" type="hidden" value="1">
                            <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                            <ul data-bind="foreach: pages">
                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                            </ul>
                            <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ${this.resultInfos.getHtmlBuild()}
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <!-- ko ifnot: brandId -->
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'brandOwner') }, css: { 'list-sort-desc': orderByAndDirection()=='brandOwner_DESC', 'list-sort-asc': orderByAndDirection()=='brandOwner_DESC' }">Brand</span></th>
                            <!-- /ko -->
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'productSchemaTemplate') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Product Schema.org Template</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dataset') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Dataset</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: {data: tagTypes, as: 'tagType'}">
                        <tr class="cursor" >
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: tagType.id"></span></a></td>
                            <!-- ko ifnot: $parent.brandId -->
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a class="right-click" data-bind="attr: { href : emakiView }">
                                    <!-- ko if: tagType.brandOwner -->
                                    <span data-bind="attr: { class: tagType.brandOwner.iconImage + ' dark square-icon' }"></span>
                                    <!-- /ko -->
                                </a>
                            </td>
                            <!-- /ko -->
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: tagType.name"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: tagType.productSchemaTemplate"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: tagType.dataset"></span></a></td>

                        </tr>
                    </tbody>
                </table>
            </div>
          `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);
        this.datasetFilter = new filterDataset_template("datasetFilter", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {
        return "tagTypesList_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }
    protected setDatasetFilter(datasets) {

        this.getTemplateViewModel().datasetFilter.datasets(datasets);
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            orderBy: ko.observable("name"),
            orderByDirection: ko.observable("ASC"),
            tagTypes: ko.observableArray([]),
            orderByAndDirection: ko.observable("name_ASC"),
            isAddButtonShown: ko.observable(true),
            brandId: ko.observable(undefined),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            onClickView: (value) =>  {
                self.onClickView(value);
            },
            onClickShowPopUp: () =>  {
                self.onClickShowPopUp()
            },
        };
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy
            , orderByDirection: this.getTemplateViewModel().orderByDirection
            , orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            , pagination: this.getTemplateViewModel().pagination
            ,filters      : {
                keyword : this.getTemplateViewModel().filter.filterKeyword,
                idDataset: this.getTemplateViewModel().datasetFilter.idDataset,
            },
        }
    }


    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.tagsListReorder();
    }

    public setTagTypes(tagTypes) {

        this.getTemplateViewModel().tagTypes(tagTypes);
    }

    public setAddButtonShown(isAddButtonShown: boolean) {

        this.getTemplateViewModel().isAddButtonShown(isAddButtonShown);
    }

    public setBrandId(brandId?: number): void {

        this.getTemplateViewModel().brandId(brandId);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public onClickView(value) {

        this.caller.viewTagType(value.id);
    }

    public onClickShowPopUp() {

        this.caller.createTagType();
    }

    public getBrandId(): number {

        return this.caller.getBrandId();
    }

    public isBrand(): boolean {

        return this.caller.isBrand();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/tagTypesList_template.ts